import Navbar from "@/components/ikra/Navbar";
import Hero from "@/components/ikra/Hero";
import MeetTheTeam from "@/components/ikra/MeetTheTeam";
import BrandAmbassador from "@/components/ikra/BrandAmbassador";
import CoreValues from "@/components/ikra/CoreValues";
import ApplyForm from "@/components/ikra/ApplyForm";
import Footer from "@/components/ikra/Footer";

export default function HomePage() {
  return (
    <div data-testid="home-page" className="bg-[var(--ikra-bg)] text-[var(--ikra-ink)] font-body">
      <Navbar />
      <main>
        <Hero />
        <MeetTheTeam />
        <BrandAmbassador />
        <CoreValues />
        <ApplyForm />
      </main>
      <Footer />
    </div>
  );
}
